__turbopack_context__.v({
  "inputAddOnBefore": "input-module-scss-module__P3v28W__inputAddOnBefore",
  "inputBox": "input-module-scss-module__P3v28W__inputBox",
  "loginInputBox": "input-module-scss-module__P3v28W__loginInputBox",
  "variableAmountInput": "input-module-scss-module__P3v28W__variableAmountInput",
});
